export const validateEmail = (email) => {
  const emailRegex = /^[\p{L}0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/u;

  const forbiddenChars = /[!#$%^&*()=<>?\/\\,{}|~:;'"\[\]\s]/;

  const invalidFormat = /^\.|\.\.|\.@|@\.|\.$|^-|-$|@-|-$|^-|@[-.]|[-.]@/;

  return emailRegex.test(email) && !forbiddenChars.test(email) && !invalidFormat.test(email);
};
